import angular from 'angular';

angular
  .module('indexfile', [])

  .config([
    '$stateProvider',
    function($stateProvider) {
      $stateProvider.state('unknown-batchref', {
        data: {
          authorizedRole: 'USER_BO'
        }
      });
    }
  ]);
